<template>
  <div class="member-page">
    <TopTitle title="企业信息" />
    <el-tabs v-model="tabActiveName">
      <el-tab-pane label="成员管理" name="1">
        <div class="list-tabs">
          <el-button type="text" :class=" activeName == 1 ? 'button-active member-list' : 'member-list'" @click="switchTab(1)">成员列表</el-button>
          <el-badge is-dot class="item" :hidden="applyList.length<1" v-if="userData.isAdmin">
            <el-button type="text" :class=" activeName == 2 ? 'button-active' : ''" @click="switchTab(2)">新的成员</el-button>
          </el-badge>
        </div>
        <div class="member-list-tab-page" v-if="activeName==1">
          <div class="search-content-input">
            <el-input placeholder="输入昵称、手机号码、邮箱" suffix-icon="el-icon-search" v-model="searchContent" @change="getData()"></el-input>
            <div class="table-oper-nav" style="margin-top:0">
              <el-link icon="iconfont icon-yaoqingxinren" type="primary" :underline="false" @click="inviteShow" v-if="userData.companyStatus == 20 && userData.companyUserStatus == 1">邀请新人</el-link>
            </div>
          </div>
          <div class="member-list-table global-table">
            <el-table :data="memberList" style="width: 100%" :row-class-name="tableRowClassName">
              <el-table-column prop="" label="企业角色">
                <template slot-scope="scope">
                  <span>{{scope.row.isAdmin?'管理员':'员工'}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="nickname" label="昵称">
              </el-table-column>
              <el-table-column prop="phone" label="手机号">
              </el-table-column>
              <el-table-column prop="email" label="邮箱">
              </el-table-column>
              <el-table-column fixed="right" label="操作" width="270" v-if="userData.isAdmin">
                <template slot-scope="scope">
                  <div class="table-btn">
                    <!-- <el-link type="primary" :underline="false" @click="openChangeAdminDialog" v-if="scope.row.isAdmin">
                      <img :src="require('@/assets/user/shift.png')" class="btn-img">
                      <span class="btn-text">转移管理员</span>
                    </el-link>
                    <el-link type="primary" :underline="false" @click="handExidUser(scope.row.userId)" v-else>
                      <img :src="require('@/assets/user/kick.png')" class="btn-img">
                      <span class="btn-text">踢出企业</span>
                    </el-link> -->
                    <el-link icon="iconfont icon-a-zhuanyiguanliyuan20 change-admin" type="primary" :underline="false" @click="openChangeAdminDialog" v-if="scope.row.isAdmin">转移管理员</el-link>
                    <el-link icon="iconfont icon-a-tichuqiye20" type="primary" :underline="false" @click="handExidUser(scope.row.userId)" v-if="!scope.row.isAdmin">踢出企业</el-link>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="global-page">
            <el-pagination background @size-change="changePageSize" @current-change="changePage" :page-sizes="[15, 30, 45, 60]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :current-page="currentPage" :total="total">
            </el-pagination>
          </div>
        </div>
        <div class="new-member-tab-page" v-if="activeName==2 && userData.isAdmin">
          <div class="member-list-table global-table">
            <el-table :data="applyList" style="width: 100%">
              <el-table-column prop="nickname" label="昵称">
              </el-table-column>
              <el-table-column prop="phone" label="手机号码">
              </el-table-column>
              <el-table-column prop="email" label="邮箱">
              </el-table-column>
              <el-table-column fixed="right" label="操作" width="270">
                <template slot-scope="scope">
                  <div class="table-btn">
                    <el-link type="primary" :underline="false" @click="handrejectUser(scope.row.userId)">驳回</el-link>
                    <el-link type="primary" :underline="false" class="agree-btn" @click="handAgreeUser(scope.row.userId)">同意</el-link>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <!-- 转移管理员 -->
    <el-dialog title="转移管理员" :visible.sync="dialogVisible" width="780px" class="member-dialog" :close-on-click-modal="false">
      <div class="search-content-input">
        <el-input placeholder="输入昵称、手机号码、邮箱" suffix-icon="el-icon-search" v-model="adminSearchContent" @change="getChangeAdminList"></el-input>
      </div>
      <div class="member-list-table dialog-global-table">
        <el-table :data="changeAdminList" style="width: 100%">
          <el-table-column label="选择" width="60">
            <template slot-scope="scope">
              <el-checkbox :value="scope.row.userId == selectId" @change="changeSelectAdmin(scope.row.userId)"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="企业角色">
            <template slot-scope="scope">
              <span>{{scope.row.isAdmin?'管理员':'员工'}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="nickname" label="昵称">
          </el-table-column>
          <el-table-column prop="phone" label="手机号">
          </el-table-column>
          <el-table-column prop="email" label="邮箱">
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="cancel-btn" @click="dialogVisible=false">取消</el-button>
        <el-button type="primary" class="submit-btn" @click="submitChangeAdmin">确认提交</el-button>
      </span>
    </el-dialog>
    <!-- 邀请新人 -->
    <InviteMember :visible.sync="inviteDialogVisible" @close="close" v-if="inviteDialogVisible"></InviteMember>
  </div>

</template>

<script>
import { httpAjax } from "@/api/ajax";
import { mapActions } from "vuex";
import TopTitle from '@/components/TopTitle'
import InviteMember from '@/components/InviteMember'
const rulePhone = /^\d{11}$/;///^(13[0-9]|14[5-9]|15[012356789]|166|17[0-8]|18[0-9]|19[8-9])[0-9]{8}$/;// 手机号码校验规则
export default {
  name: "Member",
  components: {
    TopTitle,
    InviteMember
  },  
  data() {
    // 手机号验证
    const phoneValidate = async(rule, value, callback) => {
      if (value.length < 1) {
        return callback(new Error('手机号码不能为空'));
      } else if (!rulePhone.test(value)) {
        return callback(new Error('手机号码格式不正确'));
      } else{
        callback();
      }
    };
    return {
      tabActiveName:'1',
      searchContent:'',
      adminSearchContent:'',
      dialogVisible:false,
      inviteDialogVisible:false,
      loading:false,
      activeName: this.$route.params.type || "1",
      memberList:[],
      applyList:[],
      changeAdminList:[],
      currentPage: 1,
      total: 1,
      pageSize: 15,
      selectId:'',
      userData:''
    }
  },
  mounted() {
    this.getData();
    this.getData(2);//获取是否有新成员申请
    this.getUserInfo();
  },
  methods: {
    ...mapActions(['user/getUserData']),
    // 获取公司成员
    getData(type){
      this.loading = true;
      let params =  {
        status: type ? type : this.activeName, //  1在职  2 申请加入
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        keyWord:this.searchContent
      }
      if(this.activeName == 2 || type){
        params.keyWord = '';
      }
      httpAjax({
        url: '/services/company/employee',
        method: 'get',
        data:params
      }).then(response => {
        this.loading = false
        if (response.success) {
          if(this.activeName == 2 || type){
            this.applyList =  response.data
          }else{
            this.memberList =  response.data
            this.total = Number(response.pager.total)
            this.pageSize = response.pager.pageSize
          }
        } else {
          this.$message({
            message: response.msg,
            type: 'error'
          })
        }
      });
    },
    //管理员这一行背景色突出
    tableRowClassName({row}) {
      if(row.isAdmin){
        return 'admin-row';
      }
      return '';
    },
    //切换成员tab显示
    switchTab(type){
      this.activeName = type;
      if(type == 2){
        this.currentPage = 1;
        this.pageSize = 100;//新成员申请列表不分页
      }else{
        this.currentPage = 1;
        this.pageSize = 15;
      }
      this.getData();
    },
    //驳回用户
    handrejectUser(id){
      this.$confirm('确定驳回该申请?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        httpAjax({
          url: `/services/company/rejectUser/${id}`,
          method: 'post',
        }).then(response => {
          if (response.success) {
            this.$message({
              type: 'success',
              message: '操作成功!'
            });
            this.getData();
          } else {
            this.$message({
              message: response.msg,
              type: 'error'
            })
          }
        });
      }).catch(() => {});
    },
    //同意用户申请加入
    handAgreeUser(id){
      this.$confirm('确定同意该申请?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        httpAjax({
          url: `/services/company/aggreUser/${id}`,
          method: 'post',
        }).then(response => {
          if (response.success) {
            this.$message({
              type: 'success',
              message: '操作成功!'
            });
            this.getData();
          } else {
            this.$message({
              message: response.msg,
              type: 'error'
            })
          }
        });
      }).catch(() => {});
    },
    //打开转移管理员弹框
    openChangeAdminDialog(){
      this.dialogVisible = true;
      this.getChangeAdminList();
    },
    //获取可转移管理员列表
    getChangeAdminList(){
      let params =  {
        status: 1,
        currentPage: 1,
        pageSize: 200,
        keyWord:this.adminSearchContent
      }
      httpAjax({
        url: '/services/company/employee',
        method: 'get',
        data:params
      }).then(response => {
        if (response.success) {
          if(response.data.length>0){
            response.data[0].isAdmin ? (this.changeAdminList = response.data.slice(1)) : (this.changeAdminList = response.data)
          }else{
            this.changeAdminList = []
          }
        } else {
          this.$message({
            message: response.msg,
            type: 'error'
          })
        }
      });
    },
    //选择用户转移管理员
    changeSelectAdmin(id){
      this.selectId = id;
    },
    //转移管理员
    submitChangeAdmin(){
      let id = this.selectId;
      if(id){
        httpAjax({
          url:`/services/company/changeAdmin/${id}`,
          method: 'post',
        }).then(response => {
          if (response.success) {
            this.$message({
              type: 'success',
              message: '转移成功!'
            });
            this.dialogVisible = false;
            this['user/getUserData']()
            this.getData();
          } else {
            this.$message({
              message: response.msg,
              type: 'error'
            })
          }
        });
      }else{
        this.$message({
          message: '请选择需要转移管理员的目标成员',
          type: 'warning'
        });
      }
    },
    //踢出企业
    handExidUser(id){
      this.$confirm('确认将该成员踢出企业?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        httpAjax({
          url:`/services/company/exitUser/${id}`,
          method: 'post',
        }).then(response => {
          this.$message({
            type: 'success',
            message: '操作成功!'
          });
          this.getData();
        });
      }).catch(() => {});
    },
    //邀请新人
    inviteShow(){
      this.inviteDialogVisible = true;
    },
    // 关闭邀请新人弹窗
    close() {
      this.inviteDialogVisible = false;
    },
    // 获取用户信息
    getUserInfo() {
      this.loading = true;
      httpAjax({
        url: `/services/user/currentUser`,
        method: "get",
      }).then((response) => {
        if (response.success) {
          this.userData = response.data;
        }
      })
    },
    // 切换页码
    changePage(page) {
      this.currentPage = page
      this.getData();
    },
    // 切换每页数量
    changePageSize(size) {
      this.pageSize = size;
      this.getData();
    },
  }
}
</script>

<style scoped lang="less">
.member-page {
  height: 100%;
  padding: 0 24px;
  background: #ffffff;
  /deep/.list-tabs {
    margin-top: 10px;
    [type="button"] {
      vertical-align: middle;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #000000;
      width: 88px;
      padding: 11px 0px;
      border-radius: 4px;
    }
    .member-list {
      margin-right: 16px;
    }
    [type="button"]:hover {
      background: #eff5ff;
      color: #1170eb;
    }
    [type="button"].button-active {
      background: #eff5ff;
      color: #1170eb;
    }
    .el-badge__content.is-dot {
      height: 10px;
      width: 10px;
      top: 14px;
      right: 18px;
      background: #ff1212;
    }
  }
  .member-list-tab-page .search-content-input {
    display: flex;
    align-items: center;
    margin-top: 24px;
    .table-oper-nav {
      margin-left: 24px;
    }
  }
  /deep/.search-content-input {
    .el-input {
      width: 260px;
      height: 32px;
    }
    .el-input--suffix .el-input__inner:hover {
      border: 1px solid #1170eb;
    }
    .el-input--suffix .el-input__inner:focus {
      border: 1px solid #1170eb;
    }
    .el-input--suffix .el-input__inner {
      width: 100%;
      height: 100%;
      background: #ffffff;
      border-radius: 2px;
      border: 1px solid rgba(0, 0, 0, 0.15);
      padding-left: 16px;
    }
    .el-input__icon {
      line-height: 32px;
    }
  }
  /deep/.member-list-table {
    margin-top: 16px;
    .el-link--inner {
      // display: flex;
      // align-items: center;
    }
    .btn-img {
      width: 12px;
      height: 12px;
    }
    .btn-text {
      padding-left: 8px;
      font-family: PingFangSC-Regular, PingFang SC;
    }
    .table-btn .iconfont {
      margin-right: 6px !important;
      font-weight: 500;
      font-size: 12px;
    }
    // .table-btn .change-admin {
    //   font-size: 12px;
    // }
    .agree-btn {
      padding-left: 16px !important;
    }
    .admin-row {
      background: #ecf1ff;
    }
  }
  .member-dialog {
    .search-content-input .el-input {
      margin-top: 0;
    }
    .dialog-footer {
      text-align: right;
      margin-top: 24px;
    }
  }
}
</style>